import { render, staticRenderFns } from "./relation_fine_form.vue?vue&type=template&id=4086904b&scoped=true"
import script from "./relation_fine_form.vue?vue&type=script&lang=js"
export * from "./relation_fine_form.vue?vue&type=script&lang=js"
import style0 from "./relation_fine_form.vue?vue&type=style&index=0&id=4086904b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086904b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4086904b')) {
      api.createRecord('4086904b', component.options)
    } else {
      api.reload('4086904b', component.options)
    }
    module.hot.accept("./relation_fine_form.vue?vue&type=template&id=4086904b&scoped=true", function () {
      api.rerender('4086904b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/budget/categories/components/relation_fine_form.vue"
export default component.exports